import {DeviceVersion, MarketingDetails} from '@/types';
import { ApiBaseService, ApiV2Service } from '@/services/api.base.service';

export class MarketingDetailsService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getMarketingDetails(versionId: number): Promise<DeviceVersion> {
    return this.api.get(`admin/deviceVersions/${versionId}/marketing`);
  }

  public async saveMarketingDetails(marketingDetails: MarketingDetails): Promise<MarketingDetails> {
    return this.api.post(`admin/deviceVersions/${marketingDetails.device_version_id}/marketing`, marketingDetails);
  }

  public async updateMarketingDetails(marketingDetails: MarketingDetails): Promise<MarketingDetails> {
    return this.api.put(`admin/deviceVersions/${marketingDetails.device_version_id}/marketing`, marketingDetails);
  }
}

export default new MarketingDetailsService();
